export default __webpack_public_path__ + "static/media/navi-hey-listen.8055e09a.mp3";